import { createContext } from 'react';
import type { ReferralStats } from '../types/referral';

export interface ReferralStoreContextValue {
  referralStats: ReferralStats;
  loading: boolean;
  error: Error | null;
  reloadStats: () => Promise<void>;
  copyReferralLink: (referralCode: string) => Promise<void>;
}

export const ReferralStoreContext = createContext<ReferralStoreContextValue | undefined>(undefined);

